<script setup>
defineProps({ reviews: { type: Array, default: () => [] } });
const stars = rating =>
  '★'.repeat(Math.max(0, Math.min(5, Number(rating) || 0)));
</script>

<!-- eslint-disable vue/no-bare-strings-in-template @intlify/vue-i18n/no-raw-text vue/no-root-v-if -->
<template>
  <section
    v-if="reviews.length"
    class="border-t border-n-weak p-3"
    aria-label="订单匹配评论"
    data-test="order-matched-reviews"
  >
    <div class="mb-3 flex flex-wrap items-center justify-between gap-2">
      <h3 class="m-0 text-sm font-semibold text-n-slate-12">
        亚马逊评论 · {{ reviews.length }}
      </h3>
      <span class="rounded bg-n-blue-3 px-2 py-0.5 text-xs text-n-blue-11">
        精准匹配
      </span>
    </div>
    <article
      v-for="review in reviews"
      :key="review.review_id"
      class="mb-3 rounded-lg border border-n-weak p-3 last:mb-0"
    >
      <div class="flex flex-wrap items-center gap-2 text-xs">
        <span
          class="font-semibold text-n-amber-11"
          :aria-label="`${review.rating} 星`"
        >
          {{ stars(review.rating) }} {{ review.rating }} 星
        </span>
        <span
          v-if="review.availability === 'unavailable'"
          class="text-n-ruby-11"
        >
          评论已删除
        </span>
      </div>
      <p class="mb-1 mt-2 text-sm font-medium text-n-slate-12">
        {{ review.title_zh || review.title }}
      </p>
      <p class="mb-2 text-xs text-n-slate-10">
        {{ review.reviewer_name }} ·
        {{ String(review.reviewed_on || '').slice(0, 10) }}
      </p>
      <p
        class="mb-2 max-h-36 overflow-y-auto whitespace-pre-wrap break-words text-sm leading-6 text-n-slate-12"
      >
        {{ review.body_zh || review.body }}
      </p>
      <details
        v-if="review.body_zh || review.title_zh"
        class="mb-2 text-xs text-n-slate-11"
      >
        <summary class="cursor-pointer">查看原文</summary>
        <p class="mt-2 font-medium">{{ review.title }}</p>
        <p
          class="max-h-36 overflow-y-auto whitespace-pre-wrap break-words leading-5"
        >
          {{ review.body }}
        </p>
      </details>
    </article>
  </section>
</template>
